"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regularPriceForLicense = exports.currentPriceForLicense = exports.stringsForLicenseType = void 0;
const i18n_1 = require("@completeanatomy/i18n");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const stringsForLicenseType = (type) => {
    switch (type) {
        case bridge_schema_1.LicenseType.StudentPlus:
            return i18n_1.Strings.store.licenses.studentPlus;
        case bridge_schema_1.LicenseType.Edu:
            return i18n_1.Strings.store.licenses.educator;
        case bridge_schema_1.LicenseType.Pro:
            return i18n_1.Strings.store.licenses.pro;
        default:
            throw new Error(`Unexpected value: ${type}`);
    }
};
exports.stringsForLicenseType = stringsForLicenseType;
const EMPTY_PRICE = {
    formattedValue: '--.--',
    formattedValuePrefix: '--.--',
};
function currentPriceForLicense(license) {
    if (!license.product) {
        return EMPTY_PRICE;
    }
    if (!license.product.offer) {
        return license.product.price;
    }
    return license.product.offer.price;
}
exports.currentPriceForLicense = currentPriceForLicense;
function regularPriceForLicense(license) {
    if (!license.product) {
        return EMPTY_PRICE;
    }
    return license.product.price;
}
exports.regularPriceForLicense = regularPriceForLicense;
